import { GSpinner } from '~/presentation/ui';
import { Box, Text } from '@shopify/polaris';
import { t } from 'i18next';

interface PopoverStatusProps {
  isLoading?: boolean;
  isShowNoData?: boolean;
  minHeight?: string;
}

export const PopoverStatus: React.FC<PopoverStatusProps> = ({
  isLoading,
  isShowNoData,
  minHeight,
}) => {
  if (!isLoading && !isShowNoData) return null;

  const getContent = () => {
    if (isLoading) return <GSpinner size="small" />;
    if (isShowNoData) return <Text as="p">{t('No options found.')}</Text>;

    return null;
  };

  return (
    <Box padding={'300'} minHeight={minHeight || '100px'}>
      {getContent()}
    </Box>
  );
};
